import styled, { css } from 'styled-components';

export type DotProps = {
  color: string;
  size: number;
};

export const Dot = styled.div<DotProps>(({
  color,
  size,
}) => css`
  display: inline-flex;
  width: ${size}px;
  height: ${size}px;
  border-radius: 50%;
  background-color: ${color};
`);

export default Dot;
